import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom';

export const useNavigationPrompt = (shouldBlock: boolean, message: string) => {
  const blocker = useBlocker(shouldBlock);

  useEffect(() => {
    if (blocker.state !== 'blocked') {
      return;
    }

    if (window.confirm(message)) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker, message]);
};
